import { mediaUploadRequest, transferResumableFile } from './resumableUpload'

// Session URLs and Files remain in memory. A same-page retry can continue from
// storage's acknowledged offset or repeat finalization without duplicating bytes.
export async function uploadMediaAsset(client, path, file, fields, options = {}, config = {}) {
  const requestConfig = { ...config, ...(options.signal ? { signal: options.signal } : {}) }
  const post = (url, data) => {
    if (Object.keys(requestConfig).length) return client.post(url, data, requestConfig)
    if (data === undefined) return client.post(url)
    return client.post(url, data)
  }
  const reportPhase = (phase) => options.onPhase?.(phase)
  reportPhase('starting')
  let session = options.session
  if (!session) {
    const response = await post(path, mediaUploadRequest(file, fields))
    session = response.data.upload
    options.onSession?.(session)
  }
  if (!options.transferComplete) {
    reportPhase('transferring')
    await transferResumableFile(file, session, options.onProgress, fetch, {
      signal: options.signal,
      onBytesProgress: options.onBytesProgress,
      onStorageSession: options.onStorageSession,
      onRetry: () => reportPhase('reconnecting'),
    })
  }
  reportPhase('preparing')
  const completed = await post(`${path}/${session.id}/complete`)
  return completed.data.asset
}
